import QuoteStep from "../../enums/QuoteStep";
import TqPanelUpdateForm from "./TqPanelUpdateForm";

const TqPanelUpdate = ({ watch2, STATE }) => (
  <div className="tw-min-w-[350px] max-[1023px]:tw-hidden">
    {STATE.currentStep === QuoteStep.TQ_PANEL && (
      <div className="tw-rounded-[14px] tw-border tw-border-solid tw-border-dis-border tw-bg-white tw-px-5 tw-py-6">
        <h1 className="tw-mb-5 tw-mt-0 tw-text-left tw-text-xl tw-text-dis-navy">
          Customise your quote
        </h1>
        <div className="tw-mt-0 tw-mb-0 tw-text-sm [&_label]:tw-text-base [&_label]:tw-font-bold">
          <TqPanelUpdateForm
            STATE={STATE}
            bonusValue={watch2("bonus")?.value}
            useInternalBonus={false}
            buttonSize="small"
          />
        </div>
      </div>
    )}
  </div>
);

export default TqPanelUpdate;
